export const validate = (props) => (values) => {
  const errors = {};

  if (!values.body || values.body.length < 10) {
    errors.body = props.intl.formatMessage({
      id: 'reviews.requiredText',
      defaultMessage: 'Text length must be at least 10 characters long',
    });
  }

  if (values.body && values.body.length > 1000) {
    errors.body = props.intl.formatMessage({
      id: 'reviews.textTooLong',
      defaultMessage: 'Text length must be less than 1000 characters long',
    });
  }

  return errors;
};
